import { useAuth0 } from '@auth0/auth0-react'
import { isAuthorizedByRole } from 'utils/auth0'
import { useNavigate } from 'react-router-dom'
import AddCircleIcon from '@mui/icons-material/AddCircle'

const ButtonNewProject = () => {
  const { user } = useAuth0()
  const navigate = useNavigate()

  if (!isAuthorizedByRole(user, 'Master')) return null

  return (
    <button
      className="crear-proyecto-button"
      onClick={() => navigate('/proyectos/nuevo')}
    >
      <AddCircleIcon style={{ fontSize: '1.4rem' }} />
      Crear proyecto
    </button>
  )
}

export default ButtonNewProject
